// hooks/useModalPosition.ts
import { useState, useRef } from 'react';
import { View } from 'react-native';

export const useModalPosition = () => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [position, setPosition] = useState<{
    x: number;
    y: number;
    width: number;
    height: number;
  } | null>(null);
  const ref = useRef<View>(null);

  const openModal = () => {
    ref.current?.measureInWindow((x, y, width, height) => {
      setPosition({ x, y, width, height });
      setShowModal(true);
    });
  };

  const closeModal = () => {
    setShowModal(false);
  };

  return {
    ref,
    showModal,
    position,
    openModal,
    closeModal,
  };
};
